import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const options = Array.from({ length: 109 }, (_, i) => i + 12).map((i) => ({
  label: `${i.toString()} meses`,
  value: `${i}`,
}))

export const strategy = optionsToStrategy(options)
